module.exports = __webpack_public_path__ + "img/terminology.29c863c6.jpg";